<template>
    <div class="content">
        <!--        粒子特效插件-->
        <vue-particles color="#fff" :particleOpacity="0.7" :particlesNumber="100" shapeType="circle" :particleSize="4"
            linesColor="#fff" :linesWidth="1" :lineLinked="true" :lineOpacity="0.4" :linesDistance="150" :moveSpeed="2"
            :hoverEffect="true" hoverMode="grab" :clickEffect="true" clickMode="push" class="lizi">
        </vue-particles>
        <el-form :model="loging" :rules="rules" ref="loging" label-width="80px" class="login-box">
            <h3 class="login-title" style="font-size: 32px">
                欢迎登录千机汇业务看板
            </h3>
            <el-form-item label="账号" prop="username">
                <el-input prefix-icon="el-icon-user" v-model="loging.loginName" autocomplete="off"
                    placeholder="请输入账号"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password" style="margin-top: 30px">
                <el-input prefix-icon="el-icon-lock" :type="flag ? 'text' : 'password'" v-model="loging.password"
                    autocomplete="off" placeholder="请输入密码">
                    <i slot="suffix" :class="flag ? 'fa fa-eye' : 'fa fa-eye-slash'"
                        style="margin-top:12px;font-size:16px;color: #515151;cursor: pointer" autocomplete="auto"
                        @click="flag = !flag" />
                </el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="verifyCode" class="verifyCodeItemCss" style="margin-top: 30px">
                <el-row :span="24">
                    <el-col :span="17">
                        <el-input prefix-icon="el-icon-key" class="verify_css" placeholder="请输入4位验证码"
                            v-model="loging.code" @keyup.enter.native="submitForm('ruleForm')"></el-input>
                    </el-col>
                    <!--关键 ↓-->
                    <el-col :span="7">
                        <img :src="imgsrc" alt="" @click="getCode">
                    </el-col>
                </el-row>
            </el-form-item>
            <div class="button-box" style="margin-top: 32px;margin-left: 150px">
                <el-button type="primary" @click="logIn" @keyup.enter="logIn" style="margin-left: -25px">登录</el-button>
                <el-button type="danger" @click="reset" style="margin-left: 25px">重置</el-button>
                <el-button type="primary" @click="full">全屏切换</el-button>
            </div>

        </el-form>
    </div>
</template>

<script>
import { Login, getcode } from '../utils/api.js'
import md5 from 'md5'
export default {
    data() {
        return {
            flag: false,
            loging: {
                loginName: '',
                password: '',
                code: '',
                uuid: '',
            },
            imgsrc: '',
            rules: {
                loginName: { required: true, message: "账号不能为空", trigger: "blur" },
                password: { required: true, message: "密码不能为空", trigger: "blur" },
                code: { required: true, message: "请输入验证码", trigger: "blur" },
            },
        }
    },
    created() {
        this.getCode()
    },
    mounted() {

        // 绑定监听事件
        window.addEventListener("keydown", this.keyDown);
    },
    destroyed() {
        // 销毁事件
        window.removeEventListener("keydown", this.keyDown, false);
    },
    components: {},
    methods: {
        full() {
            if (!document.fullscreenElement) {
                document.documentElement.requestFullscreen();
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                }
            }
        },
        // 登录
        logIn() {
            this.$refs['loging'].validate((valid) => {
                if (!valid) {
                    this.$message.error({
                        message: "请填写账号密码或验证码",
                        duration: 2000
                    });
                } else {


                    let data = {
                        loginName: this.loging.loginName,
                        password: md5(this.loging.password),
                        code: this.loging.code,
                        uuid: this.loging.uuid
                    }
                    Login(data).then(res => {
                        console.log(res);
                        if (res.code == 200 && res.data.token != null) {
                            localStorage.setItem('token', res.data.token)
                            this.$router.push('/home')
                        } else {
                            if (res.data.msgTip == 'user password error') {
                                this.$message.error('密码错误')
                            } else if (res.data.msgTip == 'user is not exist') {
                                this.$message.error('用户不存在')
                            }
                        }
                    })
                    this.getCode()
                }
            })
        },
        // 点击回车键登录
        keyDown(e) {
            // 回车则执行登录方法 enter键的ASCII是13
            if (e.keyCode === 13) {
                this.logIn(); // 定义的登录方法
            }
        },
        // 重置
        reset() {
            this.loging = {
                loginName: '',
                password: '',
                code: '',
            }
        },
        getCode() {
            getcode().then(res => {
                console.log(res)
                if (res.code == 200) {
                    this.imgsrc = res.data.base64
                    this.loging.uuid = res.data.uuid
                    localStorage.setItem('uuid', this.loging.uuid)
                }
            })
        }

    },
}
</script>

<style scoped>
.content {
    width: 100%;
    height: 100%;
    /*background: linear-gradient(rgb(51, 153, 255), rgb(144, 201, 243));*/
    position: absolute;
    background-image: url("../assets/img/bg2.jpg");
    background-size: cover;
}

.lizi {
    position: absolute;
    width: 100%;
    height: calc(100% - 50px);
}

.login-box {
    position: absolute;
    border: 1px solid #dcdfe6;
    width: 470px;
    height: 350px;
    /*margin: 180px auto;*/
    background-color: rgba(255, 255, 255, 0.85);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 35px 85px 15px 35px;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    box-shadow: 0 0 25px #909399;
    /*opacity: 0.9;*/
}

.login-title {
    text-align: center;
    margin: 0 auto 40px auto;
    color: #303133;
    margin-left: 52px;
}

/* /deep/ .el-form-item__label {
    line-height: 40px;
    font-size: 16px;
}

/deep/ .el-input__inner {
    height: 40px;
} */

.verify_css {
    width: 270px;
}

.button-box {
    margin: auto;
}

/* /deep/ .el-button {
    width: 40%;
    height: 35px;
    font-size: 14px;
} */
</style>